import { render } from "./SmallEventItem.vue?vue&type=template&id=89de8668&ts=true"
import script from "./SmallEventItem.vue?vue&type=script&lang=ts"
export * from "./SmallEventItem.vue?vue&type=script&lang=ts"

import "./SmallEventItem.vue?vue&type=style&index=0&id=89de8668&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__